/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_AnchorInputs */

const cs_field_anchor = /** @type {(inputs: Field_AnchorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kotevní pole`)
};

const en_field_anchor = /** @type {(inputs: Field_AnchorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anchor field`)
};

/**
* | output |
* | --- |
* | "Anchor field" |
*
* @param {Field_AnchorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_anchor = /** @type {((inputs?: Field_AnchorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_AnchorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_anchor(inputs)
	return cs_field_anchor(inputs)
});